import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Changelogs from '../../../../components/CoreComponents/Changelog/Changelogs.tsx';
import DetailsHeader from "../../../../components/CoreComponents/Details/SectionHeader.tsx";
import CheckListButtons from './CheckListButtons';
import TaskDetails from './ChecklistDetails';
import PunchLists from "./PunchLists.tsx";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store.ts';
import Comments from '../../../../components/CoreComponents/Comments/Comments.tsx';
import { getByPath } from '../../../../Helpers/Functions.ts';

export default function DetailsDD() {
    const { path } = useParams()
    const { ChecklistsObject } = useSelector((state: RootState) => state.SequenceObject)
    const item = getByPath(path, ChecklistsObject)

    // Open the details page at the top. The checklist list restores its scroll
    // position (often far down the page) before navigating here, and there is no
    // global scroll-to-top on route change, so without this the details page
    // would inherit that scroll offset and open scrolled to the bottom.
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [path])

    return (
        <div className='max-w-4xl'>
            <div className='mt-2'>
                <CheckListButtons {...{ path, item }} />
            </div>
            <DetailsHeader title="Checklist Details" />
            <div>
                <TaskDetails item={item} />
            </div>
            <hr className="border-t mt-8 mb-8" />
            <div className='mt-16'>
                <Comments item={item} />
            </div>
            <div className='mt-16 mb-8'>
                <PunchLists item={item} />
            </div>
            <div className='mt-16 mb-8'>
                <Changelogs item={item} />
            </div>
        </div>
    )
}
